import { render, staticRenderFns } from "./EmergencyAction.vue?vue&type=template&id=40567e02&scoped=true"
import script from "./EmergencyAction.vue?vue&type=script&lang=js"
export * from "./EmergencyAction.vue?vue&type=script&lang=js"
import style0 from "./EmergencyAction.vue?vue&type=style&index=0&id=40567e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40567e02",
  null
  
)

export default component.exports